<template>
    <div class="map-loader">
        <img class="map-img"
             :src="publicPath+src"/>
        <div class="points">
            <map-point
                    v-for="point in points"
                    :key="point.id"
                    :label="point.titletxt+''"
                    :x="point.mapPosition.x"
                    :y="point.mapPosition.y"
                    :url="point.url()"
                    :small="small"
                    :left="point.mapPosition.left"
            ></map-point>
        </div>
    </div>
</template>

<script>
    import MapPoint from "./MapPoint";
    export default {
        name: "MapLoader",
        components: {MapPoint},
        props:{
            src:{
                type:String
            },
            /**
             * @type {PageFokoModel[]|PageRoyaumeModel[]}
             */
            points:{
                type:Array
            },
            small:{
                type:Boolean,
                default:false
            }
        },
        data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },
        computed:{

        }
    }
</script>

<style lang="less">
    .map-loader{
        //outline: 1px solid yellow;
        position: relative;
        .map-img{
            display: block;
            height: 100%;
            width: 100%;
            outline-offset: -2px;
            //outline: 1px solid pink;
            margin: 0;
        }
        .points{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            //outline: 1px solid yellow;
            >*{
                position: absolute;
            }
        }

    }
</style>